<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on: menu }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon
            v-on="{ ...tooltip, ...menu }"
          >
            <img
              v-if="model"
              :src="model.flagSrc"
              width="25"
              height="25"
              style="border-radius: 50%"
            >
            <v-icon v-else>
              mdi-earth
            </v-icon>
          </v-btn>
        </template>
        <span v-if="model">{{model.title}}</span>
      </v-tooltip>
    </template>
    <v-list v-model="model">
      <v-list-item
        v-for="language in languages"
        :key="language.id"
        @click="changeLanguage(language)"
      >
        <v-list-item-avatar
          size="24"
        >
          <v-img :src="language.flagSrc" />
        </v-list-item-avatar>
        <v-list-item-title>{{ language.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>

  export default {
    props: {
      currentLanguage: {
        type: String,
        required: false,
        default: null,
      },
    },
    data: () => ({
      languages: [
        {
          id: 1,
          title: 'فارسی',
          lang: 'fa',
          rtl: true,
          flagSrc: require('@/assets/iran.png'),
        },
        {
          id: 2,
          title: 'English',
          lang: 'en',
          rtl: false,
          flagSrc: require('@/assets/england.png'),
        },
        // {
        //   id: 3,
        //   title: 'عربی',
        //   lang: 'ar',
        //   rtl: true,
        //   flagSrc: 'https://www.countryflags.com/wp-content/uploads/saudi-arabia-flag-png-large.png',
        // },
        // {
        //   id: 4,
        //   title: 'کوردی',
        //   lang: 'ku',
        //   rtl: true,
        //   flagSrc: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/Flag_of_Kurdistan.png/800px-Flag_of_Kurdistan.png',
        // },
      ],
      model: null,
    }),
    mounted () {
      var index = this.languages.findIndex(x => x.lang === this.$store.state.lang)
      this.model = this.languages[index]
      if (this.model) {
        this.$emit('input', this.model)
      }
      var langStorage = localStorage.getItem('lang')
      if (langStorage) {
        this.$root.$i18n.locale = langStorage.lang
        this.$emit('input', langStorage)
      }
    },
    methods: {
      changeLanguage (lang) {
        this.model = lang
        var storage = JSON.parse(localStorage.getItem('token'))
        if (storage) {
          storage.init.lang.value = lang.lang
          localStorage.setItem('token', JSON.stringify(storage))
          this.$root.$i18n.locale = lang.lang
          this.$emit('input', lang)
        } else {
          localStorage.setItem('lang', JSON.stringify(lang))
          this.$root.$i18n.locale = lang.lang
          this.$emit('input', lang)
        }
        this.$vuetify.rtl = lang.rtl
      },
    },
  }
</script>

<style lang="scss" scoped></style>
